import { Fragment, useState } from 'react';
import * as s from './GateRail.css';

type LoginStep = 'name' | 'method' | 'otp' | 'password' | 'success';
type Branch = 'otp' | 'password' | 'passkey' | null;
type NodeState = 'completed' | 'current' | 'future';

export interface GateRailProps {
  currentStep: LoginStep;
}

const BRANCH_LABEL: Record<Exclude<Branch, null>, string> = {
  otp: 'OTP',
  password: 'PWD',
  passkey: 'PASSKEY',
};

/**
 * 접속 단계 레일 — SYS.GATE 줄 아래 한 줄. IDENT ▸ AUTH ▸ (가지) ▸ LINK.
 * 갈림길은 고르기 전엔 OTP/PWD 한 칸, 고른 뒤엔 그 가지 하나만 보인다.
 */
export function GateRail({ currentStep }: GateRailProps) {
  // 고른 가지는 성공 단계까지 기억한다 (NeuralPath 와 같은 규칙)
  const [branch, setBranch] = useState<Branch>(null);
  if ((currentStep === 'otp' || currentStep === 'password') && branch !== currentStep) {
    setBranch(currentStep);
  } else if (currentStep === 'success' && branch === null) {
    setBranch('passkey');
  }

  const idx = ['name', 'method', 'mid', 'success'].indexOf(
    currentStep === 'otp' || currentStep === 'password' ? 'mid' : currentStep
  );
  const stateAt = (i: number): NodeState =>
    i < idx ? 'completed' : i === idx ? 'current' : 'future';

  const nodes = [
    { label: 'IDENT', state: stateAt(0) },
    { label: 'AUTH', state: stateAt(1) },
    { label: branch ? BRANCH_LABEL[branch] : 'OTP/PWD', state: stateAt(2) },
    { label: 'LINK', state: stateAt(3) },
  ];

  return (
    <ol className={s.rail} aria-label="접속 단계">
      {nodes.map((n, i) => (
        <Fragment key={n.label}>
          {i > 0 && (
            <span className={s.separator} aria-hidden="true">
              ▸
            </span>
          )}
          <li
            className={s.node}
            data-state={n.state}
            aria-current={n.state === 'current' ? 'step' : undefined}
          >
            {n.label}
          </li>
        </Fragment>
      ))}
    </ol>
  );
}
